// Globals
import { FC, useMemo, useRef } from 'react';
import { BaseSelectRef } from 'rc-select';
import { SelectProps } from 'antd';

// Modules
import { getChannelsOptions } from '@/modules/Channels';
import { selectActiveChannels, selectChannels } from '@/modules/Channels/feature';

// Store
import { useAppState } from '@/store';

// Components
import { Select } from '@/ui';

type TChannelsSelectProps = {
  onChange?: (channelId?: number) => void;
  value?: number | null;
  isLoading?: boolean;
  showOnlyActive?: boolean;
  disabled?: boolean;
  allowClear?: boolean;
  placeholder?: string;
  size?: SelectProps['size'];
};

const ChannelsSelect: FC<TChannelsSelectProps> = ({
  onChange,
  value,
  isLoading,
  showOnlyActive,
  disabled,
  allowClear,
  placeholder,
  size,
}) => {
  const selectRef = useRef<BaseSelectRef>(null);
  const activeChannels = useAppState(selectActiveChannels);
  const channels = useAppState(selectChannels);

  const options = useMemo(
    () => getChannelsOptions(showOnlyActive ? activeChannels : channels),
    [activeChannels, channels, showOnlyActive],
  );

  const handleSelect = () => selectRef.current?.blur();

  return (
    <Select
      ref={selectRef}
      showSearch
      loading={isLoading}
      options={options}
      value={value}
      onChange={onChange}
      onSelect={handleSelect}
      disabled={disabled}
      allowClear={allowClear}
      placeholder={placeholder}
      size={size}
    />
  );
};

export default ChannelsSelect;
